import { render, staticRenderFns } from "./ApiDataSelect.vue?vue&type=template&id=1c225625&scoped=true"
import script from "./ApiDataSelect.vue?vue&type=script&lang=js"
export * from "./ApiDataSelect.vue?vue&type=script&lang=js"
import style0 from "./ApiDataSelect.vue?vue&type=style&index=0&id=1c225625&prod&lang=scss"
import style1 from "./ApiDataSelect.vue?vue&type=style&index=1&id=1c225625&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c225625",
  null
  
)

export default component.exports